// extracted by mini-css-extract-plugin
module.exports = {"chain":"AddChain_chain__1abL0","title":"AddChain_title__3S3CL","subtitle":"AddChain_subtitle__2bfY5"};